import React from 'react';
import ReactFitText from 'react-fittext';
import styles from '../address-home.module.css';

const NewYorkHome = () => {
  return (
    <React.Fragment>
      <ReactFitText compressor={0.4} maxFontSize={50}>
        <div className={styles.info}>
          new
          <br /> york
        </div>
      </ReactFitText>
      <ul className={styles.list}>
        <li className={styles.item}>79 Madison Avenue, 2nd Floor</li>
        <li className={styles.item}>New York, NY 10016</li>
        <li className={styles.item}>
          <span className={styles.desktopTel}>646-854-6095</span>
          <a href="tel:646-854-6095" className={styles.mobileTel}>
            646-854-6095
          </a>
        </li>
      </ul>
    </React.Fragment>
  );
};

export default NewYorkHome;



// WEBPACK FOOTER //
// ./src/components/address-home/new-york-home/index.js